import CurrentWeekCard from "@/features/certifications/overview/components/CurrentWeekCard";
import WeekRow from "@/features/certifications/overview/components/WeekRow";
import { WeekListProps } from "@/features/certifications/overview/components/types";
import type { ModuleOverview } from "@/domains/certifications/types";
import { MODULE_STATUSES } from "@/domains/certifications/constants";

import "./styles.css";

const WeekList = ({ slug, weeks, contentKey, opensAt }: WeekListProps) => {
  const currentIndex = weeks.findIndex(
    (week) => week.status === MODULE_STATUSES.CURRENT,
  );
  const current = currentIndex === -1 ? undefined : weeks[currentIndex];
  const before = current ? weeks.slice(0, currentIndex) : weeks;
  const after = current ? weeks.slice(currentIndex + 1) : [];
  const nextLockedId = weeks.find(
    (week) => week.status === MODULE_STATUSES.LOCKED,
  )?.module.id;

  const renderGroup = (group: ModuleOverview[]) =>
    group.length > 0 && (
      <ul className="certification-card week-list-group">
        {group.map((week) => (
          <WeekRow
            key={week.module.id}
            slug={slug}
            week={week}
            showUnlockReason={week.module.id === nextLockedId}
            opensAt={opensAt}
          />
        ))}
      </ul>
    );

  return (
    <div className="flex flex-col gap-300">
      {renderGroup(before)}

      {current && (
        <CurrentWeekCard slug={slug} week={current} contentKey={contentKey} />
      )}

      {renderGroup(after)}
    </div>
  );
};

export default WeekList;
